<template>
  <section id="container">
    <section id="user-visual" class="mypage">
      <div class="grid--con">
        <div class="user-visual-txt">마이페이지<!--<span> 내 정보와 원정보, 결제내역을 확인할 수 있습니다.</span>--></div>
      </div>
    </section>
    <section id="lnb"
             v-if="mode == 'srvcInfo'">
      <div class="grid--lnb">
        <div class="grid--con">
          <div class="pt-lnb">
            <ul>
              <li v-for="(tab, index) in tabList"
                  :key="'tab_'+index"
                  :class="selTabCd == tab.cd ? 'current' : ''"
                  @click="tabClick(tab.cd)">
                <a href="javascript:;">{{tab.nm}}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <div id="content" class="sub" v-if="showAt">
      <div class="grid--con-sub">
        <!-- 마이페이지 목록 -->
        <template v-if="mode=='myPage'">
          <ul class="my-main-info __grid--3">
            <li>
              <div href="javascript:;" class="box-type04 type1">
                <div class="my-main-box">
                  <div class="entry-title">
                    <div class="img-com __icon09"><span>아이콘</span></div>내 정보 수정
                  </div>
                  <table class="tb-none mgt80 h30">
                    <colgroup>
                      <col style="width:32%;">
                      <col style="width:*;">
                    </colgroup>
                    <tbody>
                    <tr>
                      <th>회원명</th>
                      <td>{{mberInfo.mberNm}}</td>
                    </tr>
                    <tr>
                      <th>휴대폰 번호</th>
                      <td>{{mberInfo.cttpc}}</td>
                    </tr>
                    <tr>
                      <th>이메일</th>
                      <td>{{mberInfo.email}}</td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="btn-wrap" style="margin-top:91px">
                    <button class="big _bt-blue wp100"
                            @click="btn_myInfoClick()"><span>수정하기</span></button>
                  </div>
                </div>
              </div>
            </li>
            <template v-for="(srvcInfo, index) in mberSrvcFcltList">
              <li :key="'srvcInfo'+index">
                <div href="javascript:;" class="box-type04 type2">
                  <div class="my-main-box">
                    <div class="entry-title"><div class="img-com __icon10">
                      <span>아이콘</span></div>{{srvcInfo.srvcNm}}
                    </div>
                    <div class="entry-txt"><span class="pc02">서비스 정보를 확인</span>할 수 있습니다.</div>
                    <a href="javascript:;"
                       class="my-main-txt-info"
                       :class="srvcInfo.svcSttus == 'STP' ? 'stop': ''">
                      <div class="tit">{{srvcInfo.fcltNm}}
                        <span v-if="srvcInfo.svcSttus == 'STP'">(중지)</span>
                      </div>
                      <div class="txt mgt10">서비스 시작일
                        <div class="img-com __gubun01"><span>구분</span></div>
                        {{srvcInfo.svcBgnde.substring(0, 4) + '.' + srvcInfo.svcBgnde.substring(4, 6) + '.' + srvcInfo.svcBgnde.substring(6, 8)}}
                      </div>
                    </a>
                    <div class="btn-wrap mgt30">
                      <button class="big _bt-blue wp100"
                              @click="btn_srvcInfoClick(srvcInfo)"><span>자세히 보기</span></button>
                    </div>
                  </div>
                </div>
              </li>
            </template>
          </ul>
        </template>

        <!-- 내정보 수정 -->
        <template v-if="mode=='myInfo'">
          <h1 class="tit-type1">내 정보 수정</h1>
          <table class="tb-row">
            <colgroup>
              <col style="width: 200px;">
              <col>
            </colgroup>
            <tbody>
            <tr>
              <th class="__left">성명</th>
              <td>{{mberInfo.mberNm}}</td>
            </tr>
            <tr>
              <th class="__left">아이디</th>
              <td>{{mberInfo.id}}</td>
            </tr>
            <tr>
              <th class="__left">비밀번호</th>
              <td>
                <div v-if="!editAt||(editSe!='pw'&&editAt)">
                  <p style="float: left;padding:11px 10px 10px 0;font-size: 14px;">※ 보안을 위해 정기적으로 비밀번호 수정을 권장합니다.</p>
                  <button ref="btn_editPw"
                          class="middle _bt-white"
                          @click="btn_editClick('pw')"
                          v-if="!editAt">
                    <span>수정</span>
                  </button><br/>
                </div>
                <div v-if="editAt&&editSe=='pw'">
                  <p style="font-size: 14px;">※ 비밀번호는 8-15자리의 영문/숫자/특수문자를 함께 입력해주세요.</p>
                  <p class="mgt30" style="font-weight: bold;font-size: 15px;">현재 비밀번호</p>
                  <input class="mgt15" type="password"
                         style="width: 275px !important;" placeholder="현재 비밀번호" title="현재 비밀번호"
                         maxlength="15" ref="curPassword"
                         v-model="curPassword" ><br/>
                  <p style="font-weight: bold;font-size: 15px;" class="mgt30">새 비밀번호</p>
                  <input class="mgt15" type="password"
                         style="width: 275px !important;" placeholder="새 비밀번호" title="새 비밀번호"
                         maxlength="15" ref="newPassword"
                         v-model="newPassword"
                         @keyup.space="spaceKeyUp('new')"><br/>
                  <input class="mgt5" type="password"
                         style="width: 275px !important;" placeholder="새 비밀번호 확인" title="새 비밀번호 확인"
                         maxlength="15" ref="chkPassword"
                         v-model="chkPassword"
                         @keyup.space="spaceKeyUp('chk')"><br/>
                  <button ref="btn_editPwCancel"
                          class="middle _bt-white mgt15 mgl0"
                          @click="btn_editCancelClick()">
                    <span>수정 취소</span>
                  </button>
                  <button ref="btn_editPwCmplt"
                          class="middle _bt-blue mgt15"
                          @click="btn_editCmpltClick('pw')">
                    <span>수정 완료</span>
                  </button>
                </div>
              </td>
            </tr>
            <tr>
              <th class="__left">
                휴대폰번호
              </th>
              <td>
                <div v-if="!editAt||(editSe!='cttpc'&&editAt)">
                  <p style="float: left;padding:10px 10px 10px 0;">{{ mberInfo.cttpc }}</p>
                  <button ref="btn_changePw"
                          class="middle _bt-white"
                          @click="btn_editClick('cttpc')"
                          v-if="!editAt">
                    <span>수정</span>
                  </button>
                </div>
                <div v-if="editAt&&editSe=='cttpc'">
                  <p style="font-size: 14px;">※ 아이디/비밀번호 찾기, 보육관련 정보를 수신할 새로운 휴대폰번호를 입력해주세요.</p>
                  <p class="mgt30" style="font-weight: bold;font-size: 15px;">현재 휴대폰번호</p>
                  <p class="mgt15">{{ mberInfo.cttpc }}</p>
                  <p class="mgt30 mgb15" style="font-weight: bold;font-size: 15px;">새 휴대폰번호</p>
                  <select style="width:80px !important;" v-model="cttpcInfo.cttpc1"
                          :disabled="phoneCrtfctn.time > 0"
                          @change="cancelchkCrtfy">
                    <option>010</option>
                    <option>011</option>
                    <option>016</option>
                    <option>017</option>
                    <option>018</option>
                    <option>019</option>
                  </select> -
                  <input type="text" class="mgl5"
                         style="width:80px !important;" maxlength="4"
                         ref="cttpc2"
                         @keyup="$onbiLib.onlyNumberKeyup()"
                         @keydown="$onbiLib.onlyNumberKeydown()"
                         :disabled="phoneCrtfctn.time > 0"
                         @change="cancelchkCrtfy()"
                         v-model="cttpcInfo.cttpc2" /> -
                  <input type="text" class="mgl5"
                         style="width:80px !important;" maxlength="4"
                         ref="cttpc3"
                         @keyup="$onbiLib.onlyNumberKeyup()"
                         @keydown="$onbiLib.onlyNumberKeydown()"
                         :disabled="phoneCrtfctn.time > 0"
                         @change="cancelchkCrtfy()"
                         v-model="cttpcInfo.cttpc3"/>
                  <button ref="btn_sendNum"
                          style="width: 69px;"
                          class="middle"
                          :class="setBtnClass('btn_sendNum')"
                          @click="btn_crtfctnClick()">
                    <template v-if="clickCnt == 0">인증</template>
                    <template v-if="clickCnt > 0">재인증</template>
                  </button>
                  <br/>
                  <div class="input-span">
                    <input type="text" placeholder="인증번호 입력(3분 이내)"
                           class="mgt10" style="width:275px !important;"
                           maxlength="6" ref="crtfyNum"
                           v-model="cttpcInfo.crtfyNum"
                           :disabled="phoneCrtfctn.timer == null || phoneCrtfctn.time==0"
                           :style="{opacity: phoneCrtfctn.timer == null||phoneCrtfctn.time==0?'#50%':''}"
                           @keyup.enter="btn_cnfrmNumClick"
                           @keydown="$onbiLib.onlyNumberKeydown()"
                           @keyup="$onbiLib.onlyNumberKeyup()"/>
                    <span class="timer">{{setTimerShow}}</span>
                    <button style="width: 69px;"
                            class="middle mgt10"
                            :class="setBtnClass('btn_crtfy')"
                            @click="btn_cnfrmNumClick()"><span>확인</span></button>
                  </div>
                  <br/>
                  <br/>
                  <button ref="btn_editPwCancel"
                          class="middle _bt-white mgt15 mgl0"
                          @click="btn_editCancelClick()">
                    <span>수정 취소</span>
                  </button>
                  <button ref="btn_editPwCmplt"
                          class="middle _bt-blue mgt15"
                          @click="btn_editCmpltClick('cttpc')">
                    <span>수정 완료</span>
                  </button>
                </div>
              </td>
            </tr>
            <tr>
              <th class="__left">이메일</th>
              <td>
                <div v-if="!editAt||(editSe!='email'&&editAt)">
                  <p style="float: left;padding:10px 10px 10px 0;">{{ mberInfo.email }}</p>
                  <button ref="btn_changePw"
                          class="middle _bt-white"
                          @click="btn_editClick('email')"
                          v-if="!editAt">
                    <span>수정</span>
                  </button>
                </div>
                <div v-if="editAt&&editSe=='email'">
                  <p style="font-size: 14px;">※ 보육관련 정보를 수신할 새로운 이메일 주소를 입력해주세요.</p>
                  <p class="mgt30" style="font-weight: bold;font-size: 15px;">현재 이메일</p>
                  <p class="mgt15">{{ mberInfo.email }}</p>
                  <p class="mgt30 mgb15" style="font-weight: bold;font-size: 15px;">새 이메일</p>
                  <input type="text" style="width:200px !important;" v-model="newEmail" placeholder="새 이메일"/>
                  <br/>
                  <button ref="btn_editPwCancel"
                          class="middle _bt-white mgt15 mgl0"
                          @click="btn_editCancelClick()">
                    <span>수정 취소</span>
                  </button>
                  <button ref="btn_editPwCmplt"
                          class="middle _bt-blue mgt15"
                          @click="btn_editCmpltClick('email')">
                    <span>수정 완료</span>
                  </button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
          <div class="grid--con-sub mgt10">
            <div class="txt-type4">
              서비스를 더이상 이용하지 않으시나요?
              <button style="color: #3a85ff; text-decoration: underline;"
                      @click="mberSecsnInfo()">회원탈퇴 바로가기</button>
            </div>
          </div>
          <div class="btn-wrap __center mgt30">
            <button class="big _bt-white"
                    @click="btn_beforeClick()"><span>이전</span></button>
          </div>
        </template>

        <!-- 원별 정보 -->
        <template v-if="mode=='srvcInfo'">
          <!-- 신청 정보 -->
          <template v-if="selTabCd == '001'">
            <h1 class="tit-type1">서비스 정보</h1>
            <div class="f-oh">
              <table class="tb-row f-left" style="width : 49%;">
                <colgroup>
                  <col style="width: 200px;">
                  <col>
                </colgroup>
                <tbody>
                <tr style="height : 96px;">
                  <th class="__left">서비스 명</th>
                  <td>{{srvcInfo.goodsNm}}</td>
                </tr>
                <tr>
                  <th class="__left">상태</th>
                  <td>{{srvcInfo.svcSttusNm}}</td>
                </tr>
                <tr>
                  <th class="__left">서비스 기간</th>
                  <td>{{srvcInfo.svcBgnde}}{{srvcInfo.svcSttus == 'APR' ? '~' : ''}}</td>
                </tr>
                <tr>
                  <th class="__left">서비스 비용</th>
                  <td>{{$onbiLib.addComma(srvcInfo.goodsAmount)}}원/월</td>
                </tr>
                <tr>
                  <th class="__left">월결제 등록</th>
                  <td>{{$onbiLib.searchCardBnkNm(srvcInfo.cardBankCode, srvcInfo.cardCode)}} {{srvcInfo.cardNum}}
                    <button class="ssmall _bt-blue"
                            style="float:right;"
                            @click="btn_regPayCardClick()">
                      <span>{{srvcInfo.billCardSn==''? '카드등록' : '결제카드 변경'}}</span>
                    </button>
                  </td>
                </tr>
                <tr>
                  <th class="__left">서비스 신청자</th>
                  <td>{{srvcInfo.mberNm}}</td>
                </tr>
                </tbody>
              </table>
              <table class="tb-row f-right" style="width : 49%;">
                <colgroup>
                  <col style="width: 200px;">
                  <col>
                </colgroup>
                <tbody>
                <tr>
                  <th class="__left">원명</th>
                  <td>{{srvcInfo.fcltNm}}</td>
                </tr>
                <tr>
                  <th class="__left">시/도 시/군/구</th>
                  <td>{{srvcInfo.arname1}} {{srvcInfo.arname2}}</td>
                </tr>
                <tr>
                  <th class="__left">사업자번호</th>
                  <td>{{srvcInfo.bizrno}}</td>
                </tr>
                <tr>
                  <th class="__left">원장명</th>
                  <td>{{srvcInfo.ledgrNm}}</td>
                </tr>
                <tr>
                  <th class="__left">설립유형</th>
                  <td>
                    <div class="f-oh __right">
                      <div class="f-left">
                        <template v-if="!modifyFcltyTy">{{srvcInfo.fcltTyNm}}</template>
                        <template v-if="modifyFcltyTy">
                          <select style="width:200px !important;" v-model="srvcInfo.fcltyTy">
                            <option v-for="(info, index) in fcltyTyList"
                                    :key="'info_'+index"
                                    :value="info.cd">{{info.cdNm}}</option>
                          </select>
                        </template>
                      </div>
                      <button class="ssmall _bt-blue"
                              @click="modifyFcltyTy = !modifyFcltyTy"
                              v-if="!modifyFcltyTy"><span>수정</span></button>
                      <button class="ssmall _bt-blue"
                              v-if="modifyFcltyTy"
                              @click="saveFcltyTy()"><span>저장</span></button>
                      <button class="ssmall _bt-blue"
                              v-if="modifyFcltyTy"
                              @click="searchSrvcPayInfo()"><span>취소</span></button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th class="__left">전화번호</th>
                  <td>{{srvcInfo.tlphon}}</td>
                </tr>
                <tr>
                  <th class="__left">아동 수(정원)</th>
                  <td>{{srvcInfo.psncpa}}명</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="tit-type1-box">
              <h1 class="f-left tit-type1 mgb0">리더기 및 태그 수량 신청정보
                <button class="small _bt-blue"
                        @click="modifyTagOrder()">
                  <span>신청정보 변경</span>
                </button>
              </h1>
              <div class="f-right txt-type4 pdt3">무통장 입금시 입금자명은 '사업자번호'로 입금해주시기바랍니다.('-')제외</div>
            </div>
            <table class="tb-col">
              <colgroup>
                <col style="width: 7%;">
                <col style="width: 18%;">
                <!--결제상태 주석-->
                <!--<col style="width: 7%;">-->
                <col style="width: 7%;">
                <col style="width: 8%;">
                <col style="width: *%;">
                <col style="width: 6%;">
                <col style="width: 6%;">
                <col style="width: 6%;">
                <col style="width: 8%;">
              </colgroup>
              <thead>
              <tr>
                <th rowspan="2">정산 구분</th>
                <th>신청수량</th>
                <!--결제상태 주석-->
                <!--<th colspan="4">주문 / 결제정보</th>-->
                <th colspan="3">주문 / 결제정보</th>
                <th rowspan="2">납품<br/>확인서</th>
                <th colspan="2">신청서류양식</th>
                <th rowspan="2" class="last">계약서 <br/>관련 파일</th>
              </tr>
              <tr>
                <th>결제수단</th>
                <th>주문번호</th>
                <!--결제상태 주석-->
                <!--<th>결제상태</th>-->
                <th>결제금액</th>
                <th>주문수량</th>
                <th>견적서</th>
                <th>계약서</th>
              </tr>
              </thead>
              <template  v-if="tagOrderList.length > 0">
                <tbody>
                <template v-for="(orderInfo, index) in tagOrderList">
                  <template v-if="orderInfo.detectorCnt > 0||orderInfo.tagCnt > 0">
                    <tr :key="'orderInfo1'+index">
                      <td rowspan="2">{{orderInfo.orderNm}}</td>
                      <td>리더기 : {{orderInfo.detectorCnt}}대, 태그 : {{orderInfo.tagCnt}}개 </td>
                      <template v-if="orderInfo.payMean == '999'">
                        <td rowspan="2"></td>
                        <!--결제상태 주석-->
                        <!--<td rowspan="2" style="color: red;">미결제</td>-->
                        <td rowspan="2"
                            style="text-align: right;">
                          {{$onbiLib.addComma(getOrderPriceInfo(orderInfo).totPrice)}}원
                        </td>
                        <td rowspan="2"
                            style="text-align: left;">
                          리더기 : {{orderInfo.detectorCnt}}대, 태그 : {{orderInfo.tagCnt}}개&nbsp;&nbsp;
                          <template v-if="orderInfo.paymthdCd == 'P02'">
                            <button class="small _bt-purple f-right"
                                    style="height: 20px;line-height: 20px;"
                                    @click="btn_cardPayClick(orderInfo)">
                              <span>결제하기</span>
                            </button>
                          </template>
                          <template v-if="orderInfo.paymthdCd == 'P04'">
                            <button class="small _bt-blue"
                                    style="height: 20px;line-height: 20px;"
                                    @click="modifyTagOrder()">
                              <span>카드결제로 변경</span>
                            </button>
                          </template>
                        </td>
                        <td rowspan="2">
                          <button class="small _bt-gray"
                                  style="height: 20px;line-height: 20px;"
                                  @click="btn_viewDeliveryConfirm(orderInfo,'ALL')">
                            <span>보기</span>
                          </button>
                        </td>
                      </template>
                      <template v-if="orderInfo.payMean == '001'">
                        <td rowspan="2">{{orderInfo.goodsOrderSn}}</td>
                        <!--결제상태 주석-->
                        <!--<td rowspan="2">
                            <template v-if="orderInfo.payCmpltAt == 'N'">미결제</template>
                            <template v-if="orderInfo.payCmpltAt == 'Y'">결제완료</template>
                        </td>-->
                        <td rowspan="2"
                            style="text-align: right;">{{$onbiLib.addComma(orderInfo.paymentAmount)}}원</td>
                        <td rowspan="2" style="text-align: left;">
                          {{orderInfo.goodsInfoTxt}}
                        </td>
                        <td rowspan="2">
                          <button class="small _bt-gray"
                                  style="height: 20px;line-height: 20px;"
                                  @click="btn_viewDeliveryConfirm(orderInfo,'ALL')">
                            <span>보기</span>
                          </button>
                        </td>
                      </template>
                      <template v-if="orderInfo.payMean == '002'">
                        <td>{{orderInfo.detectorGoodsOrderSn}}</td>
                        <template v-if="orderInfo.detectorPayCmpltAt == 'N'">
                          <!--결제상태 주석-->
                          <!--<td style="color: red;">미결제</td>-->
                          <td style="text-align: right;">{{$onbiLib.addComma(getOrderPriceInfo(orderInfo).detectorCalTotPrice)}}원</td>
                          <td style="text-align: left;">
                            리더기 : {{orderInfo.detectorCnt}}대&nbsp;&nbsp;
                            <button class="small _bt-blue"
                                    style="height: 20px;line-height: 20px;"
                                    @click="cardPayProc(orderInfo,'DETECTOR')">
                              <span>결제하기</span>
                            </button>
                          </td>
                          <td></td>
                        </template>
                        <template v-if="orderInfo.detectorPayCmpltAt == 'Y'">
                          <!--결제상태 주석-->
                          <!--<td>결제완료</td>-->
                          <td style="text-align: right;">{{$onbiLib.addComma(orderInfo.detectorPaymentAmount)}}원</td>
                          <td style="text-align: left;">
                            {{orderInfo.detectorGoodsInfoTxt}}
                          </td>
                          <td>
                            <button class="small _bt-gray"
                                    style="height: 20px;line-height: 20px;"
                                    @click="btn_viewDeliveryConfirm(orderInfo,'DETECTOR')">
                              <span>보기</span>
                            </button>
                          </td>
                        </template>
                      </template>
                      <td rowspan="2">
                        <button class="small _bt-gray"
                                style="height: 20px;line-height: 20px;"
                                @click="btn_viewEstimate(orderInfo)">
                          <span>보기</span>
                        </button>
                      </td>
                      <td rowspan="2">
                        <button class="small _bt-gray"
                                style="height: 20px;line-height: 20px;"
                                @click="btn_viewContract(orderInfo)">
                          <span>보기</span>
                        </button>
                      </td>
                      <td class="last" rowspan="2">
                        <button class="small _bt-gray"
                                style="height: 20px;line-height: 20px;"
                                @click="uploadContract(orderInfo)">
                          <span>업로드</span>
                        </button>
                      </td>
                    </tr>
                    <tr :key="'orderInfo2'+index">
                      <td>
                        <template v-if="orderInfo.paymthdCd == 'P02'">
                          신용(체크) 카드
                        </template>
                        <template v-if="orderInfo.paymthdCd == 'P04'">
                          무통장 입금 / {{orderInfo.bankNm}}
                          <div class="mgt10">
                            {{orderInfo.accNo}}&nbsp;
                            <span class="icon-s-download"
                                  @click="downloadAcc(orderInfo.fileCd, orderInfo.uploadSn, orderInfo.downUrl)" style="cursor:pointer;">
                                                        <em class="blind">통장 아이콘</em>
                                                    </span>
                          </div>
                        </template>
                      </td>
                      <template v-if="orderInfo.payMean == '002'">
                        <td>{{orderInfo.tagGoodsOrderSn}}</td>
                        <template v-if="orderInfo.tagPayCmpltAt == 'N'">
                          <!--결제상태 주석-->
                          <!--<td style="color: red;">미결제</td>-->
                          <td style="text-align: right;">{{$onbiLib.addComma(getOrderPriceInfo(orderInfo).tagTotPrice)}}원</td>
                          <td style="text-align: left;">
                            태그 : {{orderInfo.tagCnt}}개&nbsp;&nbsp;
                            <button class="small _bt-blue"
                                    style="height: 20px;line-height: 20px;"
                                    @click="cardPayProc(orderInfo,'TAG')">
                              <span>결제하기</span>
                            </button>
                          </td>
                          <td></td>
                        </template>
                        <template v-if="orderInfo.tagPayCmpltAt == 'Y'">
                          <!--결제상태 주석-->
                          <!--<td>결제완료</td>-->
                          <td style="text-align: right;">{{$onbiLib.addComma(orderInfo.tagPaymentAmount)}}원</td>
                          <td style="text-align: left;">
                            {{orderInfo.tagGoodsInfoTxt}}
                          </td>
                          <td>
                            <button class="small _bt-gray"
                                    style="height: 20px;line-height: 20px;"
                                    @click="viewDeliveryConfirm(orderInfo,'TAG')">
                              <span>보기</span>
                            </button>
                          </td>
                        </template>
                      </template>
                    </tr>
                  </template>
                </template>
                </tbody>
              </template>

              <tbody v-if="tagOrderList.length == 0">
              <tr>
                <td colspan="9" class="last">신청내역이 없습니다.</td>
                <!--<td colspan="6" class="last">신청내역이 없습니다.</td>-->
              </tr>
              </tbody>
            </table>
          </template>

          <!-- 주문/결제 정보 -->
          <template v-if="selTabCd == '002'">
            <h1 class="tit-type1">주문/결제 내역
              <button class="small _bt-blue f-right"
                      @click="btn_monthPaySttus()">
                <span>월 이용료 기준 현황</span>
              </button>
            </h1>
            <table class="tb-col">
              <colgroup>
                <col style="width: 8%;">
                <col style="width: 10%;">
                <col style="width: 15%;">
                <col style="width: 12%;">
                <col style="">
                <col style="width: 12%;">
                <col style="width: 8%;">
                <col style="width: 8%;">
              </colgroup>
              <thead>
              <tr>
                <th>주문번호</th>
                <th>결제일</th>
                <th>결제구분</th>
                <th>결제상태</th>
                <th>결제상품</th>
                <th>결제금액</th>
                <th>카드영수증</th>
                <th class="last">거래명세서</th>
              </tr>
              </thead>
              <tbody v-if="pay.list.length > 0">
              <template v-for="(payInfo, index) in pay.list">
                <tr :key="'payInfo'+index">
                  <td>{{payInfo.goodsOrderSn}}</td>
                  <td>{{payInfo.paymentDe}}</td>
                  <td>{{payInfo.paymentSeNm}}</td>
                  <td>{{payInfo.paymentSttusNm}}</td>
                  <td>{{payInfo.goodsInfoTxt}}</td>
                  <td>{{$onbiLib.addComma(payInfo.paymentAmount)}}원</td>
                  <td>
                    <button class="small _bt-gray"
                            style="height: 20px;line-height: 20px;"
                            v-if="((payInfo.paymentSe == 'C01' || payInfo.paymentSe == 'C02') && payInfo.paymentSttusNm == '정상완료')"
                            @click="btn_printReceipt(payInfo)">
                      <span>출력</span>
                    </button>
                  </td>
                  <td class="last">
                    <button class="small _bt-gray"
                            style="height: 20px;line-height: 20px;"
                            @click="btn_orderPayTradingStat(payInfo)"
                            v-if="payInfo.paymentSe == 'C01' && payInfo.paymentSttusNm == '정상완료'">
                      <span>출력</span>
                    </button>
                  </td>
                </tr>
              </template>
              </tbody>
              <tbody v-if="pay.list.length == 0">
              <tr>
                <td colspan="7" class="last">결제내역이 없습니다.</td>
              </tr>
              </tbody>
            </table>
            <pagenavi :paginginfo="pay.pagingInfo"
                      v-if="pay.pagingInfo.totCnt > pay.pagingInfo.pageListCnt"></pagenavi>
          </template>

          <!-- 추가주문 -->
          <template v-if="selTabCd == '003'">
            <h1 class="tit-type1">추가 주문 내역
              <button class="small _bt-blue f-right"
                      @click="btn_addOrder()">
                <span>추가 주문하기</span>
              </button>
            </h1>
            <table class="tb-col">
              <colgroup>
                <col style="width: 8%;">
                <col style="width: 8%;">
                <col style="width: 12%;">
                <col style="width: 10%;">
                <col style="width: auto;">
                <col style="width: 12%;">
                <col style="width: 8%;">
                <col style="width: 8%;">
              </colgroup>
              <thead>
              <tr>
                <th>주문번호</th>
                <th>주문일</th>
                <th>결제구분</th>
                <th>결제상태</th>
                <th>결제상품</th>
                <th>결제금액</th>
                <th>카드영수증</th>
                <th class="last">거래명세서</th>
              </tr>
              </thead>
              <tbody v-if="goods.orderList.length > 0">
              <template v-for="(goods, index) in goods.orderList">
                <tr :key="'goods'+index">
                  <td>{{goods.orderNo}}</td>
                  <td>{{goods.orderDe}}</td>
                  <td>{{goods.goodsGroupNm}}</td>
                  <td>{{goods.orderSttusNm}}</td>
                  <td class="__left">
                    <a href="javascript:;"
                       @click="goodsOrderDtlsClick(goods.orderNo)">
                      {{goods.goodsInfoTxt}}
                    </a>
                    <button class="small _bt-purple f-right"
                            style="height: 20px;line-height: 20px;"
                            v-if="goods.orderSttusCode == '101'"
                            @click="goodsOrderSetleClick(goods.orderNo)">
                      <span>결제하기</span>
                    </button>
                  </td>
                  <td class="__right"
                      v-html="getTotAmount(goods)"></td>
                  <template v-if="goods.orderSttusCode == '201'||goods.orderSttusCode == '301'||
                                            goods.orderSttusCode == '302' || goods.orderSttusCode == '401'">
                    <td>
                      <button class="small _bt-gray"
                              style="height: 20px;line-height: 20px;"
                              v-if="goods.tid != ''"
                              @click="btn_printReceipt(goods)">
                        <span>출력</span>
                      </button>
                    </td>
                    <td class="last">
                      <button class="small _bt-gray"
                              style="height: 20px;line-height: 20px;"
                              @click="btn_goodsOrderTradingStat(goods)">
                        <span>출력</span>
                      </button>
                    </td>
                  </template>
                  <td v-else
                      colspan="2" class="last __center">
                    ※ 결제 후 확인가능
                  </td>
                </tr>
              </template>
              </tbody>
              <tbody v-if="goods.orderList.length == 0">
              <tr>
                <td colspan="7" class="last">추가 주문내역이 없습니다.</td>
              </tr>
              </tbody>
            </table>
            <pagenavi :paginginfo="goods.pagingInfo"
                      v-if="goods.pagingInfo.totCnt > goods.pagingInfo.pageListCnt"></pagenavi>
          </template>
          <div class="btn-wrap __center">
            <button class="big _bt-white mgt30" @click="btn_beforeClick()"><span>이전</span></button>
          </div>
        </template>
        <template v-if="mode=='mberSecsn'">
          <!-- 신청 정보 -->
          <div class="i5gam-con-grid-both">
            <template v-if="secsnStep == 1">
              <h1 class="tit-type3 f-left">회원탈퇴 안내</h1>
              <div class="f-right">
                <ul class="txt-type2-1 depth2">
                  <li>사용하고 계신 아이디 <span class="pc03">({{this.mberInfo.id}})</span>는 탈퇴하실 경우
                    <span class="pc01">재사용 및 복구가 불가능</span>합니다.
                  </li>
                  <li>탈퇴 후 회원정보 및 어린이집연결정보는 삭제되지만, 작성하신 게시물은 삭제되지 않습니다.</li>
                </ul>
                <div class="form-all mgt30">
                  <input type="checkbox" id="chk"
                         v-model="secsnInfoAgreeAt" true-value="Y" false-value="N">
                  <label for="chk"><span class="box"></span>
                    <span class="label-txt">안내 사항을 모두 확인하였으며, 이에 동의합니다.</span></label>
                </div>
              </div>
            </template>
            <template v-if="secsnStep == 2">
              <h1 class="tit-type3 f-left">비밀번호 재인증</h1>
              <div class="f-right">
                <ul class="txt-type2-1 depth2">
                  <li>비밀번호 입력 후 탈퇴버튼을 누르시면 즉시 회원 탈퇴됩니다.
                  </li>
                  <li>삭제된 계정은 복구가 불가하므로 신중하게 결정해주시기 바랍니다.</li>
                </ul>
                <p class="mgt30" style="font-weight: bold;font-size: 15px;">비밀번호 입력</p>
                <input class="mgt15" type="password"
                       style="width: 275px !important;" placeholder="비밀번호 입력" title="비밀번호 입력"
                       maxlength="15" ref="passwordCheck"
                       v-model="passwordCheck" ><br/>
              </div>
            </template>
            <div class="btn-wrap col2 mgt30 __center">
              <button class="big _bt-white mgt30" @click="btn_beforeClick()"><span>이전</span></button>
              <button class="big _bt-blue mgt30" @click="btn_nextClick()">
                <span v-if="secsnStep == 1">다음</span>
                <span v-if="secsnStep == 2">탈퇴</span>
              </button>
            </div>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
/* 추가 주문 정보*/
const mixinGoodsOrder = {
  data: function(){
    return {
      goods: {
        orderList: new Array(),
        pagingInfo : {
          totCnt: 0, /* 총게시물 수*/
          pageListCnt: 10, /* 페이지당 게시물수 */
          pageCnt: 10, /* 페이지수 */
          curPageNum: 1,/* 현재페이지 */
          callBackFunc : this.searchGoodsOrderList
        }
      }
    }
  },
  methods: {
    searchGoodsOrderList: function(){
      this.axios.post('/i5gam/goods/searchGoodsOrderList.act',{
        searchInfo: {
          fcltcd: this.selFcltcd,
        },
        pagingInfo : {
          curPageNum : this.goods.pagingInfo.curPageNum,
          startCnt : ((this.goods.pagingInfo.curPageNum-1) * this.goods.pagingInfo.pageListCnt)+1,
          endCnt : this.goods.pagingInfo.curPageNum * this.goods.pagingInfo.pageListCnt
        }
      }).then(function(response) {
        const goodsInfo = response.data.goodsInfo;
        this.goods.orderList = goodsInfo.goodsOrderList;
        this.goods.pagingInfo.totCnt = goodsInfo.pagingInfo.totCnt;
        this.goods.pagingInfo.curPageNum = goodsInfo.pagingInfo.curPageNum;
      }.bind(this)).catch(function(e) {
        console.log(e);
        this.$toasted.show(this.$onbiLib.msg.err.system);
      }.bind(this));
    },
    goodsOrderDtlsClick: function(orderNo){
      const popupInfo = {
        se:'modal',
        id:'goodsOrderDtlsPopup',
        wid:'900',
        hei:'',
        tit:'주문상세',
        draggableAt:false,
        param: {
          orderNo: orderNo,
          setleCallbackFunc: this.searchGoodsOrderList,
        }
      };

      this.$store.commit('openPopup',popupInfo);
    },
    btn_viewDeliveryConfirm : function(orderInfo,orderPaySe){
      const popupInfo = {
        se:'modal',
        id:'deliveryConfirmPopup',
        wid:'900',
        hei:'1500',
        draggableAt:true,
        param : {
          selTabCd : this.selTabCd,
          srvcInfo : this.srvcInfo,
          orderInfo : orderInfo,
          orderPaySe : orderPaySe,
          priceInfo : this.getOrderPriceInfo(orderInfo)
        }
      };
      this.$store.commit('openPopup',popupInfo);
    },
    btn_goodsOrderTradingStat : function(payInfo){
      const popupInfo = {
        se:'modal',
        id:'tradingStatPopup',
        wid:'900',
        hei:'1500',
        draggableAt:true,
        param : {
          selTabCd : this.selTabCd,
          srvcInfo : this.srvcInfo,
          payInfo  : payInfo
        }
      };

      this.$store.commit('openPopup',popupInfo);
    },
    goodsOrderSetleClick: function(orderNo){
      const popupInfo = {
        se:'modal',
        id:'goodsOrderSetlePopup',
        wid:'820',
        hei:'',
        tit:'결제',
        draggableAt:false,
        param: {
          orderNo: orderNo,
          setleCallbackFunc: this.searchGoodsOrderList,
        }
      }

      this.$store.commit('openPopup',popupInfo);
    },
    getTotAmount: function(info){
      let amount = 0;
      amount = Number(info.orderAmount) + Number(info.dlvyAmount) - Number(info.dscntAmount);

      return this.$onbiLib.addComma(amount) + '원';
    },
  },
  mounted: function(){

  }
}

/* 최초주문, 월결제 정보*/
const mixinOrderPay = {
  data: function(){
    return {
      pay: {
        list: new Array(),
        pagingInfo : {
          totCnt: 0, /* 총게시물 수*/
          pageListCnt: 10, /* 페이지당 게시물수 */
          pageCnt: 10, /* 페이지당 게시물수 */
          curPageNum: 1,/* 현재페이지 */
          callBackFunc : null
        }
      }
    }
  },
  methods: {
    btn_printReceipt: function(payInfo){
      var msg = "1. 카드영수증은 보안준수를 위해 구매시 입력한 정보를 확인하여 출력됩니다. \n\n";
      msg += "2. 구매자명은 어린이집명을 입력해 주십시오. -  예) '아이오감어린이집' 혹은 '아이오감'\n\n";
      msg += "3. 체크카드인 경우 계좌내역에 '이니시스-정기'로 표시됩니다.";

      alert(msg);
      const url = 'https://iniweb.inicis.com/DefaultWebApp/mall/cr/cm/mCmReceipt_head.jsp?noTid='+payInfo.tid+'&noMethod=1';
      const name = '카드영수증';
      const option = 'width=420, height=750';
      window.open(url,name,option);
    },
    btn_orderPayTradingStat : function(payInfo){
      const popupInfo = {
        se:'modal',
        id:'tradingStatPopup',
        wid:'900',
        hei:'1500',
        draggableAt:true,
        param : {
          selTabCd : this.selTabCd,
          srvcInfo : this.srvcInfo,
          payInfo  : payInfo
        }
      };

      this.$store.commit('openPopup',popupInfo);
    },
    btn_monthPaySttus : function(){
      const popupInfo = {
        se:'modal',
        id:'monthPaySttusPopup',
        wid:'1200',
        hei:'',
        tit:'월 이용료 기준 현황',
        draggableAt:false,
        param:{
          fcltcd : this.srvcInfo.fcltcd
        }
      };

      this.$store.commit('openPopup',popupInfo);
    },
  }
}

/* 마이페이지*/
const mixinMyPage = {
  data : function(){
    return {
      mberSrvcFcltList : new Array(),
      modifyFcltyTy : false,
    }
  },
  methods : {
    searchMberSrvcFcltList : function(){
      const _this = this;

      return new Promise(function(resolve, reject){
        _this.axios.post('/i5gam/srvc/searchMberSrvcFcltList.act',{
          mberNo : _this.mberInfo.mberNo,
          srvcCd : 'SBIW02'
        }).then(function(response) {
          resolve(response.data.mberSrvcFcltList);
        }.bind(this)).catch(function(e){
          reject(e);
        })
      });

      /*
      this.axios.post('/i5gam/srvc/searchMberSrvcFcltList.act',{
          mberNo : this.mberInfo.mberNo,
          srvcCd : 'SBIW02'
      }).then(function(response) {
          this.mberSrvcFcltList = response.data.mberSrvcFcltList;
      }.bind(this)).catch(function(e) {
          console.log(e);
          _this.$toasted.show(_this.$onbiLib.msg.err.system);
      });
      */
    },
    btn_myInfoClick : function(){
      this.mode = 'myInfo';
    },
    btn_srvcInfoClick : function(srvcInfo){
      this.selReqstSn = srvcInfo.reqstSn;
      this.selFcltcd = srvcInfo.fcltcd;
      this.mode = 'srvcInfo';
      this.searchSrvcPayInfo().then(function(){
        this.searchGoodsOrderList();
        this.selTabCd = '001';
      }.bind(this));
    },
    btn_beforeClick : function(){
      if(this.phoneCrtfctn.timer != null && this.phoneCrtfctn.time >0){
        if(confirm("휴대폰 인증이 취소됩니다. 취소하시겠습니까?")){
          clearInterval(this.phoneCrtfctn.timer);
        }else {
          return false;
        }
      }
      if(this.mode == 'mberSecsn'){
        if(this.secsnStep == 1) {
          this.secsnInfoAgreeAt = 'N'
          this.mode = 'myInfo';
        }
        else if(this.secsnStep == 2) {
          this.passwordCheck = ''
          this.secsnStep = 1;
        }
      }else{
        this.resetEditInfo();
        this.mode = 'myPage';
      }
    }
  }
}

/* 내 정보 수정 */
const mixinMyInfo = {
  computed: {
    setTimerShow: function (){
      if(this.phoneCrtfctn.timer == null) return '--:--';
      else{
        let min = Math.floor(this.phoneCrtfctn.time/60);
        let sec = this.phoneCrtfctn.time%60;
        if(sec <10){
          sec = '0'+sec
        }
        if(min == 0 && sec == 0){
          return '--:--';
        }
        return min+':'+sec;
      }
    },
  },
  data : function(){
    return {
      editAt : false,
      editSe : '',
      curPassword : '',
      newPassword : '',
      chkPassword : '',
      newEmail : '',
      cttpcInfo: {
        cttpc1: '010',
        cttpc2: '',
        cttpc3: '',
        crtfyNum: '',
        chkCrtfy: false,   //휴대폰 인증 체크
      },
      phoneCrtfctn: {
        timer: null,
        time: 0,
        cttpc1: '',
        cttpc2: '',
        cttpc3: '',
      },
      clickCnt: 0, // 인증시도 횟수
      def: {
        phoneCrtfctn: {
          timer: null,
          time: 0,
          cttpc1: '',
          cttpc2: '',
          cttpc3: '',
        },
        cttpcInfo: {
          cttpc1: '010',
          cttpc2: '',
          cttpc3: '',
          crtfyNum: '',
          chkCrtfy: false,   //휴대폰 인증 체크
        },
      }
    }
  },
  methods : {
    btn_editClick: function(editSe){
      if(this.phoneCrtfctn.timer != null && this.phoneCrtfctn.time >0){
        if(confirm("휴대폰 인증이 취소됩니다. 취소하시겠습니까?")){
          clearInterval(this.phoneCrtfctn.timer);
          this.phoneCrtfctn = JSON.parse(JSON.stringify(this.def.phoneCrtfctn));
        }else {
          return false;
        }
      }
      this.editSe = editSe;
      this.editAt = true;
    },
    btn_editCmpltClick : function(editSe){
      if(editSe == 'pw'){
        this.modifyPw();
      }else if(editSe == 'cttpc'){
        this.modifyCttpc();
      }else if(editSe == 'email'){
        this.modifyEmail();
      }
    },
    btn_editCancelClick : function(){
      if(this.phoneCrtfctn.timer != null && this.phoneCrtfctn.time >0){
        if(confirm("휴대폰 인증이 취소됩니다. 취소하시겠습니까?")){
          clearInterval(this.phoneCrtfctn.timer);
          this.phoneCrtfctn = JSON.parse(JSON.stringify(this.def.phoneCrtfctn));
        }else {
          return false;
        }
      }
      this.editAt = false;
      this.editSe = null;
      this.resetEditInfo();
    },
    modifyPw : function(){
      if(this.curPassword == ''){
        this.$toasted.show("현재 비밀번호를 입력해주세요.");
        this.$refs.curPassword.focus();
        return false;
      }

      if(!this.validCheckPw()) {
        this.$refs.newPassword.focus();
        return false;
      }

      if(this.newPassword != this.chkPassword){
        this.$toasted.show("새 비밀번호와 새 비밀번호 확인이 일치하지않습니다.");
        this.$refs.chkPassword.focus();
        return false;
      }

      this.checkPwProc().then(function(code){
        if(code == '001'){
          this.savePassword();
        }else if(code == '997'){
          this.$toasted.show('현재 비밀번호와 동일하게 변경 불가합니다.');
          this.$refs.newPassword.focus();
          return false;
        }else if(code == '998'){
          this.$toasted.show('이전 비밀번호와 동일하게 변경 불가합니다.');
          this.$refs.newPassword.focus();
          return false;
        }else if(code == '999'){
          this.$toasted.show('현재 비밀번호가 일치하지 않습니다.');
          this.$refs.curPassword.focus();
          return false;
        }
      }.bind(this)).catch(function (e) {
        console.log(e);
        this.$toasted.show(this.$onbiLib.msg.err.system);
      }.bind(this));
    },
    validCheckPw: function (){
      let chk = 0;
      if(this.newPassword.search(/[0-9]/g) != -1 ) chk ++;
      if(this.newPassword.search(/[a-z]/ig)  != -1 ) chk ++;
      if(this.newPassword.search(/[!@#$%^&*()?_~]/g)  != -1  ) chk ++;

      if((chk < 3) || (this.newPassword.length < 8 || this.newPassword.length > 15)){
        this.$toasted.show("새 비밀번호는 영문, 숫자, 특수문자를 포함하여 8~15자로 생성해주세요.");
        return false;
      }

      //같은 문자 4번 제한
      if(!this.passwdRepeatKeyChk()) return false;

      //ID포함여부 체크
      if(!this.passwdIdChk()) return false;

      //연락처 포함여부 체크
      if(!this.passwdCttpcChk()) return false;

      //연속된 문자/숫자 정규식 생성
      if(!this.passwdCntnKeyChk()) return false;

      //잘알려진단어 체크
      if(!this.passwdKnownWordChk()) return false;

      return true;
    },
    spaceKeyUp: function(info){
      this.$toasted.show('공백입력은 불가합니다.');
      if(info == 'new'){
        this.newPassword = this.newPassword.replace(/ /gi,'');
      }else if(info =='chk'){
        this.chkPassword = this.chkPassword.replace(/ /gi,'');
      }
    },
    checkPwProc : function(){
      const _this = this;

      return new Promise(function(resolve, reject){
        _this.axios.post('/i5gam/member/checkPwProc.act',{
          mberInfo : {
            mberNo : _this.mberInfo.mberNo,
            password : _this.curPassword,
            newPassword : _this.newPassword,
          }
        }).then(function(response) {
          const code = response.data.procCode;
          resolve(code);
        }.bind(this)).catch(function(e) {
          reject(e);
        });
      })
    },
    savePassword : function(){
      const _this = this;

      this.axios.post('/i5gam/member/changePwProc.act',{
        mberInfo : {
          mberNo : this.mberInfo.mberNo,
          password : this.newPassword
        }
      }).then(function() {
        this.$toasted.show('비밀번호가 ' + this.$onbiLib.msg.suc.chng, {duration:1000, type:'success'});
        this.resetEditInfo();
      }.bind(this)).catch(function(e) {
        console.log(e);
        _this.$toasted.show(_this.$onbiLib.msg.err.system);
      });
    },
    resetEditInfo : function(){
      this.curPassword = '';
      this.newPassword = '';
      this.chkPassword = '';
      this.newEmail = '';
      this.cttpcInfo = JSON.parse(JSON.stringify(this.def.cttpcInfo));
      this.phoneCrtfctn = JSON.parse(JSON.stringify(this.def.phoneCrtfctn));
      this.editSe = '';
      this.editAt = false;
    },
    cancelchkCrtfy: function (){
      if(this.cttpcInfo.chkCrtfy){
        if(this.cttpcInfo.cttpc1 != this.phoneCrtfctn.cttpc1||
            this.cttpcInfo.cttpc2 != this.phoneCrtfctn.cttpc2||
            this.cttpcInfo.cttpc3 != this.phoneCrtfctn.cttpc3){
          this.cttpcInfo.chkCrtfy = false;
          this.phoneCrtfctn = JSON.parse(JSON.stringify(this.def.phoneCrtfctn));
          this.cttpcInfo.crtfyNum = '';
        }
      }
    },
    modifyCttpc : function(){
      if(!this.cttpcInfo.chkCrtfy){
        this.$toasted.show("휴대폰 인증을 해주세요.");
        return false;
      }
      if (this.cttpcInfo.cttpc3 == '') {
        this.$toasted.show("새 휴대폰번호를 입력해주세요.");
        this.$refs.cttpc3.focus();
        return true;
      }
      const cttpc = this.cttpcInfo.cttpc1 + '-' + this.cttpcInfo.cttpc2 + '-' + this.cttpcInfo.cttpc3;

      this.axios.post('/i5gam/member/changeCttpcProc.act',{
        mberInfo : {
          mberNo : this.mberInfo.mberNo,
          cttpc : cttpc
        }
      }).then(function() {
        this.mberInfo.cttpc = cttpc;
        this.$toasted.show('휴대폰번호가 ' + this.$onbiLib.msg.suc.chng, {duration:1000, type:'success'});
        this.changeSession();
      }.bind(this)).catch(function(e) {
        console.log(e);
        this.$toasted.show(this.$onbiLib.msg.err.system);
      }.bind(this));
    },
    modifyEmail : function(){
      const _this = this;

      if(this.newEmail == ''){
        this.$toasted.show('새 이메일을 입력해주세요.');
        return false;
      }else{
        const emailValid = /[0-9a-zA-Z][_0-9a-zA-Z-]*@[_0-9a-zA-Z-]+(\.[_0-9a-zA-Z-]+){1,2}$/;
        if(!emailValid.test(this.newEmail)){
          this.$toasted.show("올바른 이메일형식을 입력해주세요.");
          return false;
        }
      }

      this.axios.post('/i5gam/member/changeEmailProc.act',{
        mberInfo : {
          mberNo : this.mberInfo.mberNo,
          email : this.newEmail
        }
      }).then(function() {
        this.mberInfo.email = this.newEmail;
        this.$toasted.show('이메일이 ' + this.$onbiLib.msg.suc.chng, {duration:1000, type:'success'});
        this.changeSession();
      }.bind(this)).catch(function(e) {
        console.log(e);
        _this.$toasted.show(_this.$onbiLib.msg.err.system);
      });
    },
    btn_crtfctnClick : function(){
      if (this.setBtnClass('btn_sendNum') == '_bt-white') return false;
      if(this.mberInfo.cttpc == this.cttpcInfo.cttpc1+'-'+this.cttpcInfo.cttpc2 +'-'+this.cttpcInfo.cttpc3){
        this.$toasted.show('현재 휴대폰 번호와 동일합니다.');
        return false;
      }
      if(this.cttpcInfo.cttpc1 == this.phoneCrtfctn.cttpc1&&
          this.cttpcInfo.cttpc2 == this.phoneCrtfctn.cttpc2&&
          this.cttpcInfo.cttpc3 == this.phoneCrtfctn.cttpc3){
        this.$toasted.show('이미 인증된 휴대폰번호 입니다.');
        return false;
      }

      if(this.cttpcInfo.cttpc2.length < 3 || this.cttpcInfo.cttpc3.length != 4){
        this.$toasted.show("휴대폰 번호를 입력해주세요.");
        return false;
      }

      if(this.cttpcInfo.cttpc2.search(/^\d{3,4}$/) === -1 || this.cttpcInfo.cttpc3.search(/^\d{4}$/) === -1){
        this.$toasted.show("숫자만 입력 가능합니다.");
        this.cttpcInfo.cttpc2 = '';
        this.cttpcInfo.cttpc3 = '';
        return false;
      }
      this.phoneJoinMberChk().then(function(joinPssbleAt){//폰번호당 아이디 5개만 가입 가능
        if(joinPssbleAt == 'Y'){
          this.phoneCrtfyNumSend();
        }else{
          this.$toasted.show('입력하신 휴대폰 번호로 가입한 ID가 5개 이상입니다.');
          return false;
        }
      }.bind(this)).catch(function (e) {
        console.log(e);
        this.$toasted.show(this.$onbiLib.msg.err.system);
      }.bind(this));
    },
    phoneJoinMberChk : function(){
      return new Promise(function (resolve, reject) {
        this.axios.post('/i5gam/member/join/phoneJoinMberChk.act',{
          cttpc : this.cttpcInfo.cttpc1 + "-" + this.cttpcInfo.cttpc2 + "-" + this.cttpcInfo.cttpc3
        }).then(function(response) {
          const joinPssbleAt = response.data.joinPssbleAt;
          resolve(joinPssbleAt);
        }.bind(this)).catch(function(e) {
          reject(e);
        });
      }.bind(this));
    },
    phoneCrtfyNumSend : function(){ //인증번호 전송
      this.axios.post('/common/crtfy/phoneCrtfyNumSend.act',{
        cttpc : this.cttpcInfo.cttpc1 + "-" + this.cttpcInfo.cttpc2 + "-" + this.cttpcInfo.cttpc3,
        srvcCd : 'SBIW02'
      }).then(function(){
        this.clickCnt += 1;
        this.$toasted.show('인증번호를 발송했습니다. 인증번호가 오지 않으면 입력하신 정보가 정확한지 확인해주세요. 발송된 인증번호는 3분간 유효합니다.', {duraion:1000, type:"info"});
        //3분 타이머 설정
        this.setCrtfctnTimer();
      }.bind(this)).catch(function(e) {
        console.log(e);
        this.$toasted.show(this.$onbiLib.msg.err.system);
      }.bind(this));
    },
    setCrtfctnTimer : function(){
      this.cttpcInfo.chkCrtfy = false;
      this.cttpcInfo.crtfyNum = '';
      clearInterval(this.phoneCrtfctn.timer);

      //타이머 설정
      this.phoneCrtfctn.time = 180;
      this.phoneCrtfctn.timer = setInterval(function () {
        if (this.phoneCrtfctn.time == 0) {
          this.cttpcInfo.chkCrtfy = false;
          this.cttpcInfo.crtfyNum = '';
          this.$toasted.show('인증번호 유효시간이 만료되었습니다. 다시 인증해주세요.');
          clearInterval(this.phoneCrtfctn.timer);
        } else {
          this.phoneCrtfctn.time--;
        }
      }.bind(this), 1000);
    },
    btn_cnfrmNumClick : function(){
      if (this.setBtnClass('btn_crtfy') == '_bt-white') return false;

      if(this.crtfyNum == ''){
        this.$toasted.show('인증번호를 입력하지 않았습니다. 수신한 인증번호를 입력해주세요.');
        return false;
      }

      const cttpc = this.cttpcInfo.cttpc1 + "-" + this.cttpcInfo.cttpc2 + "-" + this.cttpcInfo.cttpc3;
      this.axios.post('/common/crtfy/phoneCrtfyNumCnfrm.act',{
        crtfyNum: this.cttpcInfo.crtfyNum,
        cttpc : cttpc,
        mberNm : this.mberInfo.mberNm
      }).then(function(response) {
        const crtfyNumChkCode = response.data.crtfyNumChkCode;
        if(crtfyNumChkCode == '001'){
          this.cttpcInfo.chkCrtfy = true;
          this.$toasted.show('인증번호가 일치합니다.',{duration:1000,type:"info"});
          this.phoneCrtfctn.cttpc1 = this.cttpcInfo.cttpc1;
          this.phoneCrtfctn.cttpc2 = this.cttpcInfo.cttpc2;
          this.phoneCrtfctn.cttpc3 = this.cttpcInfo.cttpc3;
          clearInterval(this.phoneCrtfctn.timer);
          this.phoneCrtfctn.time = 0;
        }else if(crtfyNumChkCode == '998'){
          this.$toasted.show('인증번호를 발송한 휴대폰 번호와 현재 입력된 휴대폰 번호가 다릅니다.');
        }else if(crtfyNumChkCode == '999'){
          this.$toasted.show('인증번호가 일치하지 않습니다. 입력한 휴대폰번호와 수신한 인증번호를 다시 한번 확인해주세요.');
          this.$refs.crtfyNum.focus();
        }
      }.bind(this)).catch(function(e) {
        console.log(e);
        this.$toasted.show(this.$onbiLib.msg.err.system);
      }.bind(this));
    },
    setBtnClass : function(btnSe){
      let cls = '_bt-white'
      if(btnSe == 'btn_sendNum'){
        if(this.cttpcInfo.cttpc2.length >= 3
            && this.cttpcInfo.cttpc3.length == 4 && this.phoneCrtfctn.time == 0)  cls ='_bt-blue';
      }else if(btnSe == 'btn_crtfy'){
        if(this.cttpcInfo.crtfyNum.length == 6 && !this.cttpcInfo.chkCrtfy) cls = '_bt-blue';
      }
      return cls;
    },
    changeSession : function(){
      const _this = this;

      this.axios.post('/i5gam/member/changeSession.act',{
        id : this.mberInfo.id,
        mberNo : this.mberInfo.mberNo,
        accessRoot : 'remote'
      }).then(function() {
        _this.$store.dispatch('getLoginSession').then(function(loginInfo){
          if(loginInfo.procCode == '001'){
            _this.$store.commit('setMberInfo', loginInfo.memberInfo);
            _this.resetEditInfo();
          }else{
            _this.$store.commit('clearLoginInfo');
          }
        }).catch(function (e) {
          console.log(e);
          _this.$toasted.show(_this.$onbiLib.msg.err.system);
        });
      }.bind(this)).catch(function(e) {
        console.log(e);
        _this.$toasted.show(_this.$onbiLib.msg.err.system);
      });
    },
    passwdCttpcChk: function (){
      let cttpc = this.mberInfo.cttpc.replaceAll('-','');
      if (this.newPassword.search(cttpc.substr(3,8)) > -1) {
        this.$toasted.show("연락처가 포함된 비밀번호는 사용하실 수 없습니다.");
        return false;
      }else return true;
    },
    passwdIdChk: function (){
      if (this.mberInfo.id.length > 5) {
        if (this.newPassword.search(this.mberInfo.id) > -1) {
          this.$toasted.show("ID가 포함된 비밀번호는 사용하실 수 없습니다.");
          return false;
        }else return true;
      }
    },
    passwdRepeatKeyChk: function (){
      if (/(\w)\1\1\1/.test(this.newPassword)) {
        this.$toasted.show('비밀번호에 같은 문자를 4번 연속 사용하실 수 없습니다.');
        return false;
      }else return true;
    },
    passwdCntnKeyChk: function (){
      const max = 4;
      const cntnlimit = ["0123456789", "9876543210",
        "qwertyuiopasdfghjklzxcvbnm",
        "QWERTYUIOPASDFGHJKLZXCVBNM"]
      let Pattern;

      for (let i = 0; i < cntnlimit.length; i++) {
        let check1 = cntnlimit[i];
        let check2 = cntnlimit[i] + cntnlimit[i];
        for (let j = 0; j < check1.length; j++) {
          let x = check1.substr(j, 1);
          let y = check2.substr(j, max);
          Pattern += "[" + x + "]{" + max + ",}|" + y + "|";
        }
      }
      Pattern = new RegExp(Pattern.replace(/.$/, ""));
      if (Pattern.test(this.newPassword)) {
        this.$toasted.show("연속된 숫자와 문자를 4번 연속 사용하실수 없습니다.");
        return false;
      }else return true;
    },
    passwdKnownWordChk: function (){
      const wordLimit = ["love", "LOVE", "happy", "HAPPY", "password", "PASSWORD"
        , "iloveyou", "ILOVEYOU", "dragon", "DRAGON", "sunshine"
        , "SUNSHINE", "princess", "PRINCESS", "letmein", "LETMEIN"
        , "monkey", "MONKEY", "superman", "SUPERMAN", "hello", "HELLO"
        , "google", "GOOGLE", "apple", "APPLE", "samsung", "SAMSUNG"]
      let msg = '';
      for (let i = 0; i < wordLimit.length; i++) {
        if (this.newPassword.search(wordLimit[i]) > -1) {
          msg = wordLimit[i];
        }
      }
      if (msg != '') {
        this.$toasted.show("비밀번호에 [" + msg + "]를 사용하실수 없습니다.");
        return false;
      }else return true;
    },
  }
}

/* 신청 정보 */
const mixinSrvcInfo = {
  data : function(){
    return {
      tabList: [
        {cd: '001', nm: '신청정보'},
        {cd: '002', nm: '월이용료결제정보'},
        {cd: '003', nm: '추가 주문'},
      ],
      selTabCd: '001',
      selReqstSn : '',
      selFcltcd : '',
      srvcInfo : new Array(),
      tagOrderList : new Array(),
    }
  },
  methods : {
    searchSrvcPayInfo : function(){
      return new Promise(function(resolve, reject){
        this.axios.post('/i5gam/srvc/searchSrvcPayInfo.act',{
          searchInfo : {
            fcltcd : this.selFcltcd,
            reqstSn : this.selReqstSn,
            mberNo : this.mberInfo.mberNo
          },
          pagingInfo : {
            curPageNum : this.pay.pagingInfo.curPageNum,
            startCnt : ((this.pay.pagingInfo.curPageNum-1) * this.pay.pagingInfo.pageListCnt)+1,
            endCnt : this.pay.pagingInfo.curPageNum * this.pay.pagingInfo.pageListCnt
          }
        }).then(function(response) {
          const srvcPayInfo = response.data.srvcPayInfo;

          this.srvcInfo = srvcPayInfo.srvcInfo[0];
          this.pay.list = srvcPayInfo.payList;
          const tagOrderList = srvcPayInfo.tagOrderList;
          if(tagOrderList.length > 0){
            this.tagOrderList = tagOrderList.filter(function(info){
              return info.orderSe == '001'||info.orderSe == '002'
            });
          }else {
            this.tagOrderList = new Array();
          }
          this.pay.pagingInfo.totCnt = srvcPayInfo.pagingInfo.totCnt;
          this.pay.pagingInfo.curPageNum = srvcPayInfo.pagingInfo.curPageNum;
          this.modifyFcltyTy = false;

          resolve();
        }.bind(this)).catch(function(e) {
          reject(e)
        });
      }.bind(this));

    },
    btn_regPayCardClick: function(){
      const _this = this;

      this.searchBillCardList().then(function(billCardList){
        if(billCardList.length > 0){
          const param = {
            billCardSn : _this.srvcInfo.billCardSn,
            billCardList : billCardList,
            regNewBillCardFunc:_this.regNewBillCard,
            regBillCardFunc:_this.regBillCard
          }

          const popupInfo = {
            se:'modal',
            id:'billCardListPopup',
            wid:'860',
            hei:'',
            tit:'결제 카드 등록',
            draggableAt:false,
            param:param
          };

          _this.$store.commit('openPopup',popupInfo);
        }else{
          _this.regNewBillCard();
        }
      }).catch(function (e) {
        console.log(e);
        _this.$toasted.show(_this.$onbiLib.msg.err.system);
      });
    },
    searchBillCardList : function(){
      const _this = this;
      return new Promise(function (resolve, reject) {
        _this.axios.post('/i5gam/srvc/searchBillCardList.act',{
          mberNo : _this.mberInfo.mberNo
        }).then(function(response) {
          resolve(response.data.billCardList);
        }.bind(this)).catch(function(e) {
          reject(e);
        });

      });
    },
    regBillCard: function(billCardInfo){
      this.saveBillCardInfo(billCardInfo,"up");
    },
    regNewBillCard: function(){
      var payTypeCd = 'PT4';

      if(this.srvcInfo.mpayTy == 'CDY'){
        payTypeCd = 'PT4';
      }else if(this.srvcInfo.mpayTy == 'CRD'){
        payTypeCd = 'PT1';
      }

      var param={
        procSe: 'getBillCardInfo',
        reqstSn: this.srvcInfo.reqstSn,
        goodsCd: this.srvcInfo.goodsCd,
        goodsNm: this.srvcInfo.goodsNm,
        goodsMtAmount: this.srvcInfo.goodsMtAmount,
        goodsYearAmount: this.srvcInfo.yerGoodsAmt,
        payTypeCd: payTypeCd,
        paymthdCd: this.srvcInfo.paymthdCd != ''? this.srvcInfo.paymthdCd : 'P02',
        fcltcd: this.srvcInfo.fcltcd,
        mberNo: this.mberInfo.mberNo,
        mberNm: this.mberInfo.mberNm,
        cttpc: this.mberInfo.cttpc,
        email: this.mberInfo.email,
        reqDefrayDe: 20,
        rm: '마이페이지 결제 수단변경',
        callBackFunc:this.saveBillCardInfo
      };

      const popupInfo = {
        se:'modalBlank',
        id:'iniPayReqBillPopup',
        wid:'820',
        hei:'600',
        tit:'이니시스결제',
        draggableAt:false,
        param:param
      };

      this.$store.commit('openPopup',popupInfo);
    },
    saveBillCardInfo:function(billCardInfo,se){
      const _this = this;

      let saveSe = "new";
      if(se == "up"){
        saveSe = se;
      }

      this.axios.post('/i5gam/srvc/saveBillCardInfoProc.act',{
        saveSe: saveSe,
        reqstSn: this.srvcInfo.reqstSn,
        mberNo: this.mberInfo.mberNo,
        billCardInfo:billCardInfo
      }).then(function(response) {
        const procInfo = response.data.procInfo;
        if(procInfo.procCode == "000"){
          var billCardInfo = procInfo.billCardInfo;
          this.$toasted.show("결제카드가 " + this.$onbiLib.msg.suc.chng,{duration:1000,type:"success"});
          this.srvcInfo.billCardSn   = billCardInfo.billCardSn;
          this.srvcInfo.billkey      = billCardInfo.billkey;
          this.srvcInfo.cardBankCode = billCardInfo.cardBankCode;
          this.srvcInfo.cardCode     = billCardInfo.cardCode;
          this.srvcInfo.cardNum      = billCardInfo.cardNum;

          this.$store.commit('closePopup');
        }else{
          this.$toasted.show(this.$onbiLib.msg.err.system);
        }
      }.bind(this)).catch(function(e) {
        console.log(e);
        _this.$toasted.show(_this.$onbiLib.msg.err.system);
      });
    },
    modifyTagOrder : function(){
      if(this.tagOrderList.length == 0){
        this.$toasted.show('변경할 내역이 없습니다.');
        return false;
      }

      const orderInfo = this.tagOrderList.find(function(info){
        return info.orderSe == '001';
      });

      const selfOrderInfo = this.tagOrderList.find(function(info){
        return info.orderSe == '002';
      });

      const param = {
        fcltcd : this.srvcInfo.fcltcd,
        reqstSn : this.srvcInfo.reqstSn,
        billCardRegAt : this.srvcInfo.billCardSn == '' ? 'N':'Y',
        orderInfo : orderInfo,
        selfOrderInfo : selfOrderInfo,
        callBackFunc : this.searchSrvcPayInfo,
        tabClickFunc : this.tabClick
      }

      const popupInfo = {
        se:'modal',
        id:'modifyTagOrderPopup',
        wid:'1200',
        hei:'',
        tit:'태그수량 변경',
        draggableAt:false,
        param:param
      };

      this.$store.commit('openPopup',popupInfo);
    },
    saveFcltyTy : function(){
      const _this = this;

      this.axios.post('/i5gam/member/saveFcltyTy.act',{
        mberNo : this.mberInfo.mberNo,
        fcltyTy : this.srvcInfo.fcltyTy,
        fcltcd : this.srvcInfo.fcltcd
      }).then(function() {
        this.$toasted.show('설립유형이 ' + this.$onbiLib.msg.suc.chng, {duration:1000, type:'success'});
        this.searchSrvcPayInfo();
        this.modifyFcltyTy = false;
      }.bind(this)).catch(function(e) {
        console.log(e);
        _this.$toasted.show(_this.$onbiLib.msg.err.system);
      });
    },
    downloadAcc : function(fileCd, uploadSn, downUrl){
      if(fileCd == '' || fileCd == null){
        this.$toasted.show('신청정보 변경을 클릭하여 무통장입금할 영업사를 선택해주세요.', {duration:2000});
        return false;
      }

      const _this = this;
      const fileInfo = {fileCd: fileCd, uploadSn:uploadSn, downUrl:downUrl};

      if(this.$onbiLib.chkCdnAt(fileInfo)){
        _this.$onbiLib.getAuthKey().then(function(authKey){
          _this.$onbiLib.setCdnFileDownLoadUrl(fileInfo,encodeURIComponent(authKey));
        });
      }else{
        this.$onbiLib.setFileDownLoadUrl('/common/downloadFile.act', 'fileCd='+fileInfo.fileCd);
      }
    },
    openHwp: function(){
      window.commonPage.callWindowPopup({
        routerNm:'views.common.commonHwp',
        params:{
          docSe:'i5gam',
          docCode:'D001',
          setFieldList:[
            {fieldId:'mberNm',value:'테스트'},
            {fieldId:'sumPrice1',value:'100,000 원 (부가세 포함)'},
          ]
        }
      })
    },
    getOrderPriceInfo: function(orderInfo){
      let detectorCalTotPrice = 0;
      let detectorTotPrice = 0;
      const detectorCnt = Number(orderInfo.detectorCnt);
      let detectorCalCnt = detectorCnt;
      const detectorPrice = 300000;

      detectorTotPrice = detectorPrice * detectorCnt;
      detectorCalTotPrice = detectorTotPrice;

      /*const discountChkCnt = orderInfo.orderSe == '001'?1:0;*/
      const discountChkCnt = orderInfo.orderSe == '001'?detectorCnt:0;
      let discountCnt = 0;
      const discountPrice = 80000;
      let discountTotPrice = 0;
      if (detectorCnt > discountChkCnt) {
        discountCnt = orderInfo.orderSe == '001' ? detectorCnt - 1 : detectorCnt;
        discountTotPrice = discountPrice * discountCnt;
        detectorCalTotPrice -= discountTotPrice;
        detectorCalCnt -= discountCnt;
      }

      let tagTotPrice = 0;
      const tagCnt = Number(orderInfo.tagCnt);
      const tagPrice = 5000;
      tagTotPrice += tagPrice * tagCnt;

      const totPrice = detectorCalTotPrice + tagTotPrice;

      return {
        detectorPrice: detectorPrice,
        detectorTotPrice: detectorTotPrice,
        detectorCnt: detectorCnt,
        detectorCalTotPrice: detectorCalTotPrice,
        detectorCalCnt: detectorCalCnt,
        discountPrice: discountPrice,
        discountTotPrice: discountTotPrice,
        discountCnt: discountCnt,
        tagPrice: tagPrice,
        tagTotPrice: tagTotPrice,
        tagCnt: tagCnt,
        totPrice: totPrice,
      }
    },
    btn_viewEstimate : function(orderInfo){
      const popupInfo = {
        se:'modal',
        id:'estimatePopup',
        wid:'900',
        hei:'1500',
        draggableAt:true,
        param : {
          selTabCd : this.selTabCd,
          srvcInfo : this.srvcInfo,
          orderInfo : orderInfo,
          priceInfo : this.getOrderPriceInfo(orderInfo)
        }
      };
      this.$store.commit('openPopup',popupInfo);

    },
    viewEstimate: function(orderInfo){

      let setFieldList = new Array();
      setFieldList.push({fieldId:'mberNm',value:this.srvcInfo.fcltNm});
      setFieldList.push({fieldId:'cttpc',value:this.mberInfo.cttpc});

      let payInfo = '3. 신용(체크)카드 : 어린이집운영비카드'
      if(orderInfo.paymthdCd == 'P04') payInfo = '3. 입금계좌 : '

      setFieldList.push({fieldId:'payInfo',value:payInfo});

      const priceInfo = this.getOrderPriceInfo(orderInfo);

      if (priceInfo.detectorCnt > 0) {
        setFieldList.push({fieldId: 'goodsNm0',value: '에이티엔 걸음마 NFC 리더기'});
        setFieldList.push({fieldId: 'goodsCnt0',value: String(priceInfo.detectorCnt)});
        setFieldList.push({
          fieldId: 'goodsUnitPrice0',
          value: this.$onbiLib.addComma(priceInfo.detectorPrice) + '원'
        });
        setFieldList.push({
          fieldId: 'goodsPrice0',
          value: this.$onbiLib.addComma(priceInfo.detectorTotPrice) + '원'
        });
      }

      const tagIdx = priceInfo.detectorCnt > 0 ? '1' : '0';

      if (priceInfo.tagCnt > 0) {
        setFieldList.push({
          fieldId: 'goodsNm' + tagIdx,
          value: '에이티엔 걸음마 NFC 태그(세트당)'
        });
        setFieldList.push({fieldId: 'goodsCnt' + tagIdx,value: String(priceInfo.tagCnt)});
        setFieldList.push({
          fieldId: 'goodsUnitPrice' + tagIdx,
          value: this.$onbiLib.addComma(priceInfo.tagPrice) + '원'
        });
        setFieldList.push({
          fieldId: 'goodsPrice' + tagIdx,
          value: this.$onbiLib.addComma(priceInfo.tagTotPrice) + '원'
        });

        setFieldList.push({fieldId: 'bigo' + tagIdx,value: '원아 X 5,000원'});
      }

      if (priceInfo.discountCnt > 0 ) {
        const discountIdx = priceInfo.tagCnt > 0 ? '2' : '1';

        setFieldList.push({fieldId: 'goodsNm' + discountIdx,value: '에이티엔 걸음마 NFC 리더기 할인'});
        setFieldList.push({fieldId: 'goodsCnt' + discountIdx,value: String(priceInfo.discountCnt)});
        setFieldList.push({
          fieldId: 'goodsUnitPrice' + discountIdx,
          value: '-' + this.$onbiLib.addComma(priceInfo.discountPrice) + '원'
        });

        setFieldList.push({
          fieldId: 'goodsPrice' + discountIdx,
          value: '-' + this.$onbiLib.addComma(priceInfo.discountTotPrice) + '원'
        });
      }

      const sumPrice = this.$onbiLib.addComma(priceInfo.totPrice) + ' 원 (부가세 포함)';
      setFieldList.push({fieldId: 'sumPrice0',value: sumPrice});
      setFieldList.push({fieldId: 'sumPrice1',value: sumPrice});

      window.commonPage.callWindowPopup({
        routerNm: 'views.common.commonHwp',
        params: {
          docSe: 'i5gam',
          docCode: 'D001',
          setFieldList: setFieldList
        }
      })
    },
    uploadContract : function(orderInfo){
      const popupInfo = {
        se:'modal',
        id:'uploadContractPopup',
        wid:'500',
        hei:'',
        tit:'견적서 업로드',
        draggableAt:true,
        param : {
          orderInfo : orderInfo,
          fcltcd : this.srvcInfo.fcltcd,
          callBackFunc : this.searchSrvcPayInfo
        }
      };

      this.$store.commit('openPopup',popupInfo);
    },
    btn_viewContract : function (orderInfo) {
      const popupInfo = {
        se:'modal',
        id:'viewContractPopup',
        wid:'900',
        hei:'1500',
        draggableAt:true,
        param : {
          selTabCd : this.selTabCd,
          srvcInfo : this.srvcInfo,
          orderInfo : orderInfo,
          priceInfo : this.getOrderPriceInfo(orderInfo)
        }
      };
      this.$store.commit('openPopup',popupInfo);
    },
    viewContract: function(orderInfo){
      let setFieldList = new Array();
      const year = this.dayInfo.yy;
      const fcltNm = this.srvcInfo.fcltNm;
      const bizrno = this.srvcInfo.bizrno;
      const adres = this.srvcInfo.adres;

      const priceInfo = this.getOrderPriceInfo(orderInfo);

      let detectorMemo = '';
      if(priceInfo.detectorCnt > 0){
        const calCnt = priceInfo.detectorCalCnt;

        if(calCnt == 0) detectorMemo = '(';
        else detectorMemo = '(' + calCnt + '대X30만원';
        if(calCnt > 0&&priceInfo.discountCnt > 0) detectorMemo += ', ';
        if(priceInfo.discountCnt > 0) detectorMemo += '추가 ' + priceInfo.discountCnt + '대X22만원';
        detectorMemo += ')';
      }

      let tagMemo = '';
      if(priceInfo.tagCnt > 0){
        tagMemo = '(' + priceInfo.tagCnt + '개X개당5천원)';
      }


      setFieldList.push({fieldId:'year0',value:year});
      setFieldList.push({fieldId:'fcltNm0',value:fcltNm});
      setFieldList.push({fieldId:'bizrno',value:bizrno});
      setFieldList.push({fieldId:'adres',value:adres});
      setFieldList.push({
        fieldId:'totPrice',
        value:this.$onbiLib.addComma(priceInfo.totPrice) + '원'
      });
      setFieldList.push({
        fieldId:'detectorPrice',
        value:this.$onbiLib.addComma(priceInfo.detectorCalTotPrice) + '원' + detectorMemo
      });
      setFieldList.push({
        fieldId:'tagPrice',
        value:this.$onbiLib.addComma(priceInfo.tagTotPrice) + '원' + tagMemo
      });

      setFieldList.push({fieldId:'fcltNm1',value:fcltNm});

      setFieldList.push({fieldId:'year1',value:year});
      setFieldList.push({fieldId:'fcltNm2',value:fcltNm});
      setFieldList.push({fieldId:'adres1',value:adres});

      window.commonPage.callWindowPopup({
        routerNm: 'views.common.commonHwp',
        params: {
          docSe: 'i5gam',
          docCode: 'D002',
          setFieldList: setFieldList
        }
      })
    },
    viewDeliveryConfirm: function(orderInfo,orderPaySe){
      const _this = this;
      let setFieldList = new Array();
      const fcltNm = this.srvcInfo.fcltNm;

      setFieldList.push({fieldId:'fcltNm',value:fcltNm});

      let goodsIndex = 0;
      let goodsArray = new Array();
      if(orderInfo.payMean == '999'){
        const priceInfo = this.getOrderPriceInfo(orderInfo);

        if(orderInfo.detectorCnt > 0){
          goodsArray.push('GI0001,' + orderInfo.detectorCnt + ',대,' + priceInfo.detectorCalTotPrice);
        }
        if(orderInfo.tagCnt > 0){
          goodsArray.push('GI0002,' + orderInfo.tagCnt + ',개,' + priceInfo.tagTotPrice);
        }
      }else if(orderInfo.payMean != '999'){
        if(orderPaySe == 'ALL'){
          goodsArray = orderInfo.goodsInfo.split('/');
        }else if(orderPaySe == 'DETECTOR'){
          goodsArray = orderInfo.detectorGoodsInfo.split('/');
        }else if(orderPaySe == 'TAG'){
          goodsArray = orderInfo.tagGoodsInfo.split('/');
        }
      }

      let goodsTotAmount = 0;

      goodsArray.forEach(function(goodsInfoTxt){
        let goodsInfo = goodsInfoTxt.split(',');
        if(goodsInfo[0] == 'GI0001') {
          let goodsNm = '에이티엔 걸음마 NFC 리더기';
          let goodsStandard = 'CCAL-100';
          let goodsKorUnit = goodsInfo[2];
          let goodsCnt = Number(goodsInfo[1]);
          let goodsUnitAmount = 300000;

          if (orderInfo.orderSe == '001') {
            const goodsKorAmount = _this.$onbiLib.addComma(goodsUnitAmount) + '원';
            setFieldList.push({fieldId: 'goodsNm{{' + goodsIndex + '}}', value: goodsNm});
            setFieldList.push({
              fieldId: 'goodsStandard{{' + goodsIndex + '}}',
              value: goodsStandard
            });
            setFieldList.push({fieldId: 'goodsKorUnit{{' + goodsIndex + '}}', value: goodsKorUnit});
            setFieldList.push({fieldId: 'goodsCnt{{' + goodsIndex + '}}', value: '1'});
            setFieldList.push({
              fieldId: 'goodsUnitPrice{{' + goodsIndex + '}}',
              value: goodsKorAmount
            });
            setFieldList.push({fieldId: 'goodsPrice{{' + goodsIndex + '}}', value: goodsKorAmount});

            goodsTotAmount += goodsUnitAmount;
            goodsIndex++;
            goodsCnt -= 1;
          }

          if (goodsCnt > 0) {
            goodsUnitAmount = 220000;
            goodsNm += '(추가)';
            const goodsAmount = goodsCnt * goodsUnitAmount;
            goodsTotAmount += goodsAmount;
            const goodsKorAmount = _this.$onbiLib.addComma(goodsAmount) + '원';

            setFieldList.push({fieldId: 'goodsNm{{' + goodsIndex + '}}', value: goodsNm});
            setFieldList.push({
              fieldId: 'goodsStandard{{' + goodsIndex + '}}',
              value: goodsStandard
            });
            setFieldList.push({fieldId: 'goodsKorUnit{{' + goodsIndex + '}}', value: goodsKorUnit});
            setFieldList.push({fieldId: 'goodsCnt{{' + goodsIndex + '}}', value: String(goodsCnt)});
            setFieldList.push({
              fieldId: 'goodsUnitPrice{{' + goodsIndex + '}}',
              value: _this.$onbiLib.addComma(goodsUnitAmount) + '원'
            });
            setFieldList.push({fieldId: 'goodsPrice{{' + goodsIndex + '}}', value: goodsKorAmount});

            goodsIndex++;
          }
        }else if(goodsInfo[0] == 'GI0002'){
          let goodsNm = '에이티엔 걸음마 NFC 태그';
          let goodsStandard = 'LIBERO-30042';
          let goodsKorUnit = goodsInfo[2];
          let goodsCnt = Number(goodsInfo[1]);
          let goodsUnitAmount = 5000;

          const goodsAmount = goodsCnt * goodsUnitAmount;
          goodsTotAmount += goodsAmount;
          const goodsKorAmount = _this.$onbiLib.addComma(goodsAmount) + '원';

          setFieldList.push({fieldId: 'goodsNm{{' + goodsIndex + '}}', value: goodsNm});
          setFieldList.push({
            fieldId: 'goodsStandard{{' + goodsIndex + '}}',
            value: goodsStandard
          });
          setFieldList.push({fieldId: 'goodsKorUnit{{' + goodsIndex + '}}', value: goodsKorUnit});
          setFieldList.push({fieldId: 'goodsCnt{{' + goodsIndex + '}}', value: String(goodsCnt)});
          setFieldList.push({
            fieldId: 'goodsUnitPrice{{' + goodsIndex + '}}',
            value: _this.$onbiLib.addComma(goodsUnitAmount) + '원'
          });
          setFieldList.push({fieldId: 'goodsPrice{{' + goodsIndex + '}}', value: goodsKorAmount});
        }
      });

      setFieldList.push({fieldId:'sumPrice',value:this.$onbiLib.addComma(goodsTotAmount) + '원'});

      window.commonPage.callWindowPopup({
        routerNm: 'views.common.commonHwp',
        params: {
          docSe: 'i5gam',
          docCode: 'D003',
          setFieldList: setFieldList
        }
      })
    },
    btn_cardPayClick: function(orderInfo){
      if(orderInfo.payMean == '999'){
        if(Number(orderInfo.detectorCnt) == 0||Number(orderInfo.tagCnt) == 0){
          this.cardPayProc(orderInfo,'ALL');
        }else{
          const param = {
            orderInfo:orderInfo,
            calOrderPriceInfoFunc: this.getOrderPriceInfo,
            cardPayProcFunc: this.cardPayProc,
            cardPayCallbackFunc: this.cardPayCallback,
          };

          const popupInfo = {
            se:'modal',
            id:'selPayMeanPopup',
            wid:'720',
            hei:'',
            tit:'신용(체크)카드 결제 방법 선택',
            draggableAt:false,
            param:param
          };

          this.$store.commit('openPopup',popupInfo);
        }

      }
    },
    cardPayProc: function(orderInfo,orderPaySe,payCallback){
      //결제 테스트
      /*const procInfo = {
          procSe: 'goodsPay',
          orderSn: orderInfo.orderSn,
          orderPaySe: orderPaySe,
          resultCode: '0000',
          resultMsg: '정상처리되었습니다.',
          tid: 'StdpayCARDdocgulumma20200225172511261857'
      }

      if(payCallback != 'undefined'&&payCallback != null){
          payCallback(procInfo);
      }else{
          this.cardPayCallback(procInfo);
      }*/

      //결제 운영
      let cardPayCallback = this.cardPayCallback;
      if(payCallback != 'undefined'&&payCallback != null){
        cardPayCallback = payCallback;
      }

      const priceInfo = this.getOrderPriceInfo(orderInfo);

      let goodsCd = 'G0001';
      let goodsNm = '아이오감(보조금)';

      if(orderInfo.orderSe == '002'){
        goodsCd = 'G0002';
        goodsNm = '아이오감(자부담금)';
      }

      let goodsMtAmount = 0;

      if(orderPaySe == 'ALL'){
        goodsMtAmount = priceInfo.totPrice;
      }else if(orderPaySe == 'DETECTOR'){
        goodsNm += ' - 리더기';
        goodsMtAmount = priceInfo.detectorCalTotPrice;
      }else if(orderPaySe == 'TAG'){
        goodsNm += ' - 태그';
        goodsMtAmount = priceInfo.tagTotPrice;
      }

      const param = {
        procSe: 'goodsPay',
        reqstSn: this.srvcInfo.reqstSn,
        goodsCd: goodsCd,
        goodsNm: goodsNm,
        orderSn: orderInfo.orderSn,
        orderPaySe: orderPaySe,
        goodsMtAmount: goodsMtAmount,
        goodsYearAmount: 0,
        payTypeCd: 'PT1',
        paymthdCd: 'P02',
        fcltcd: this.srvcInfo.fcltcd,
        mberNo: this.mberInfo.mberNo,
        mberNm: this.srvcInfo.fcltNm,
        cttpc: this.mberInfo.cttpc,
        email: this.mberInfo.email,
        reqDefrayDe: '',
        rm: goodsNm + ' 실시간 카드 결제',
        callBackFunc: cardPayCallback
      };

      const popupInfo = {
        se:'modalBlank',
        id:'iniPayReqBillPopup',
        wid:'820',
        hei:'600',
        tit:'이니시스결제',
        draggableAt:false,
        param:param
      };

      this.$store.commit('openPopup',popupInfo);
    },
    cardPayCallback: function(procInfo,procCallbackFunc){
      if(procInfo.resultCode == '0000'){
        const orderPaySe = procInfo.orderPaySe;

        const orderInfo = this.tagOrderList.find(function(info){
          return info.orderSn == procInfo.orderSn;
        });
        const priceInfo = this.getOrderPriceInfo(orderInfo);

        const goodsOrderInfo = {
          reqstSn: this.srvcInfo.reqstSn,
          mberNo: this.mberInfo.mberNo,
        }

        let goodsList = new Array();

        let paymentInfo = {
          paymentSe:'C02',
          sttus:'200',
          mberNo: this.mberInfo.mberNo,
          amount:0,
        }

        if(orderPaySe == 'ALL'){
          if(priceInfo.detectorCnt>0){
            goodsList.push({
              goodsCd:'GI0001',
              orderCnt:priceInfo.detectorCnt,
              amount:priceInfo.detectorCalTotPrice,
              mberNo: this.mberInfo.mberNo,
            });

          }

          if(priceInfo.tagCnt>0){
            goodsList.push({
              goodsCd:'GI0002',
              orderCnt:priceInfo.tagCnt,
              amount:priceInfo.tagTotPrice,
              mberNo: this.mberInfo.mberNo,
            });
          }

          paymentInfo.amount = priceInfo.totPrice;
        }else if(orderPaySe == 'DETECTOR'){
          goodsList.push({
            goodsCd:'GI0001',
            orderCnt:priceInfo.detectorCnt,
            amount:priceInfo.detectorCalTotPrice,
            mberNo: this.mberInfo.mberNo,
          });

          paymentInfo.amount = priceInfo.detectorCalTotPrice;
        }else if(orderPaySe == 'TAG'){
          goodsList.push({
            goodsCd:'GI0002',
            orderCnt:priceInfo.tagCnt,
            amount:priceInfo.tagTotPrice,
            mberNo: this.mberInfo.mberNo,
          });

          paymentInfo.amount = priceInfo.tagTotPrice;
        }

        const paymentInipayInfo = {
          tid: procInfo.tid,
          mberNo: this.mberInfo.mberNo,
        }

        const tagOrderInfo = {
          reqstSn: this.srvcInfo.reqstSn,
          orderSn: orderInfo.orderSn,
          orderSe: orderInfo.orderSe,
          orderPaySe: orderPaySe
        }

        const _this = this;

        this.axios.post('/i5gam/srvc/buyI5gamGoods.act',{
          iniProcInfo: procInfo,
          goodsOrderInfo: goodsOrderInfo,
          goodsList: goodsList,
          paymentInfo: paymentInfo,
          paymentInipayInfo: paymentInipayInfo,
          tagOrderInfo: tagOrderInfo
        }).then(function() {
          this.$toasted.show('결제가 완료 되었습니다.',{duration:1000,type:"success"});
          if(procCallbackFunc != 'undefined'&&procCallbackFunc != null){
            procCallbackFunc(orderPaySe);
            this.btn_srvcInfoClick(this.srvcInfo);
          }else{
            this.btn_srvcInfoClick(this.srvcInfo);
          }

        }.bind(this)).catch(function(e) {
          console.log(e);
          _this.$toasted.show(_this.$onbiLib.msg.err.system);
        });
      }
    },
    tabClick: function(cd){
      this.selTabCd = cd;
    },
    btn_addOrder: function(){
      const popupInfo = {
        se: 'modal',
        id: 'addOrderPopup',
        wid: '1200',
        hei: '',
        tit: '상품 구매',
        draggableAt: false,
        param: {
          fcltInfo: {
            fcltNm: this.srvcInfo.fcltNm,
            fcltcd: this.srvcInfo.fcltcd,
            bizrno: this.srvcInfo.bizrno,
            zip: this.srvcInfo.zip,
            adres: this.srvcInfo.adres,
            tlphon: this.srvcInfo.tlphon,
          },
          callbackFunc: this.searchGoodsOrderList
        }
      };

      this.$store.commit('openPopup', popupInfo);
    },
  }
}

/* 회원 탈퇴 */
const mixinMberSecsn = {
  data : function(){
    return {
      passwordCheck:'',
      passwordCheckAt: false,
      secsnStep:'',
      secsnInfoAgreeAt: 'N',
    }
  },
  methods : {
    mberSecsnInfo: function (){
      this.secsnStep = 1;
      this.mode = 'mberSecsn';
    },
    btn_nextClick: function (){
      if(this.secsnInfoAgreeAt == 'N'){
        this.$toasted.show('탈퇴안내를 확인하고 동의해 주시기 바랍니다.');
        return false;
      }
      if(this.secsnStep == 1) this.secsnStep += 1;
      else this.mberSecsnClick();
    },
    mberSecsnClick: function (){
      if(this.passwordCheck.length == 0){
        this.$toasted.show("비밀번호를 입력해주세요.");
        return false;
      }
      this.axios.post('/app/common/passwordCheck.act',{
        mberNo : this.mberInfo.mberNo,
        password : this.passwordCheck,
      }).then(function(response) {
        const code = response.data.code;
        if(code == '000'){
          this.passwordCheckAt = true;
          this.searchGwUser();
        }else{
          this.passwordCheck = '';
          this.$refs.passwordCheck.focus();
          this.$toasted.show("비밀번호가 일치하지 않습니다.");
          return false;
        }
      }.bind(this)).catch(function(e) {
        console.log(e);
        this.$toasted.show(this.$onbiLib.msg.err.system);
      }.bind(this));
    },
    searchGwUser: function (){
      this.axios.post('/app/common/fcltAdminCnt.act',{
        mberNo : this.mberInfo.mberNo,
      }).then(function(response) {
        const cnt = response.data.fcltAdminCnt;
        if(cnt > 0) {
          this.$toasted.show('관리자는 회원탈퇴가 불가능합니다. 고객센터(☎ 1661-5029)로 문의해주시기 바랍니다.');
          return false;
        }else{
          this.mberSecsn();
        }
      }.bind(this)).catch(function(e) {
        console.log(e);
        this.$toasted.show(this.$onbiLib.msg.err.system);
      }.bind(this));
    },
    mberSecsn: function (){
      if(!confirm("정말 탈퇴하시겠습니까?")){
        return false;
      }
      this.axios.post('/app/common/mberSecsn.act', {
        mberNo : this.mberInfo.mberNo,
        id : this.mberInfo.id,
        appName : 'BIW'
      }).then(function(response) {
        const code = response.data.code;
        if(code == '000'){
          this.logout();
        }else{
          this.$toasted.show('회원 탈퇴에 실패하였습니다. 재시도 부탁드립니다.');
        }
      }.bind(this)).catch(function(e) {
        console.log(e);
        this.$toasted.show(this.$onbiLib.msg.err.system);
      }.bind(this));
    },
    logout: function (){
      this.$toasted.success('회원탈퇴가 완료되었습니다.')
      this.$store.dispatch('logoutProc');
      this.$router.push({ name: 'views.i5gam.index'});
    }
  }
}

/* 하단 영역 */
const mixinFooter = {
  methods : {
    openTermsPopup : function(tabSe){
      let tit = tabSe == 'tos'? '이용약관' : '개인정보처리방침';

      const popupInfo = {
        se:'modal',
        id:'termsPopup',
        wid:'1180',
        hei:'',
        tit:tit,
        draggableAt:true,
        param : {
          tabSe : tabSe
        }
      };

      this.$store.commit('openPopup',popupInfo);
    }
  }
}

export default {
  name : 'myPage',
  mixins : [mixinMyPage, mixinMyInfo, mixinSrvcInfo, mixinOrderPay, mixinGoodsOrder, mixinMberSecsn, mixinFooter],
  data : function(){
    return {
      showAt : false,
      mode : 'myPage',
      fcltyTyList : new Array()
    }
  },
  computed : {
    mberInfo : function(){
      return this.$store.getters.getMberInfo;
    },
    dayInfo: function(){
      return this.$store.getters.getDayInfo;
    },
  },
  methods : {
    init : function(){
      this.pay.pagingInfo.callBackFunc = this.searchSrvcPayInfo;

      const _this = this;
      const searchInfo = {cdGrp : 'IF1'};
      this.$onbiLib.searchCmmnCodeList(searchInfo).then(function(codeInfo){
        _this.fcltyTyList = codeInfo;
        _this.searchMberSrvcFcltList().then(function(mberSrvcFcltList){
          let fcltList = new Array();
          mberSrvcFcltList.forEach(function (info){
            if(info.adminAt == 'Y') fcltList.push(info);
          })
          _this.mberSrvcFcltList = fcltList;
          //포털에서 결제하기 버튼 클릭한 경우
          if(typeof _this.$route.params.tagOrderPayList != 'undefined'
              && _this.$route.params.tagOrderPayList != null){
            //하나인 경우는 바로 상세페이지로 이동
            if(_this.$route.params.tagOrderPayList.length == 1){
              const reqstSn = _this.$route.params.tagOrderPayList[0].reqstSn;
              const srvcInfo = _this.mberSrvcFcltList.find(function(info){
                return info.reqstSn == reqstSn;
              });

              _this.btn_srvcInfoClick(srvcInfo);
            }
          }

          _this.showAt = true;
        }.bind(this));

      }.bind(this));
    },
  },
  mounted : function(){
    this.init();
  }
}
</script>

<style scoped>
.input-span {position:relative; margin-top:-1px;}
.input-span span.timer{position:absolute;right:680px;top:8px;width:30px;
  height:40px;line-height:40px;font-size:13px;}
</style>
